export const COMPANY = {
  name: "Humlegruppen",
  legal: "Humle Åkeri AB & Humle Entreprenad AB",
  phone: "08-684 42277",
  phoneHref: "tel:+46868442277",
  email: "info@humleakeri.se",
  emailHref: "mailto:info@humleakeri.se",
  address: {
    street: "Rågstigen 19",
    zip: "137 55",
    city: "Tungelsta",
  },
  logoUrl:
    "https://customer-assets.emergentagent.com/job_haul-connect-8/artifacts/crt1a31b_humle%20akeri%20logo.png",
};

export const NAV = [
  { to: "/", label: "Hem", testid: "nav-hem" },
  { to: "/tjanster", label: "Tjänster", testid: "nav-tjanster" },
  { to: "/tillstand", label: "Tillstånd", testid: "nav-tillstand" },
  { to: "/om-oss", label: "Om oss", testid: "nav-om-oss" },
  { to: "/kontakt", label: "Kontakt", testid: "nav-kontakt" },
];
